module.exports = __webpack_public_path__ + "img/cardLayout-01.bbbed799.png";